import { jsx as a } from "react/jsx-runtime";
import { memo as i, useCallback as p } from "react";
import { Modal as u } from "antd";
import { useLanguageResolver as f } from "@biron-data/react-contexts";
const b = i(({ trigger: e, on: n, title: r, content: t }) => {
  const o = f(), m = p(() => {
    const { open: s, ok: c, cancel: l } = n;
    s(), u.confirm({
      title: r,
      content: t,
      okText: o.get("button-yes"),
      cancelText: o.get("button-no"),
      okType: "primary",
      onOk: c,
      onCancel: l,
      maskClosable: !0,
      icon: /* @__PURE__ */ a("div", {}),
      okButtonProps: {
        danger: !0
      },
      className: "widget-delete-confirmation"
    });
  }, [t, o, n, r]);
  return /* @__PURE__ */ a(e.type, { ...e.props, onClick: m });
});
export {
  b as default
};
//# sourceMappingURL=Confirm.js.map
